import PublicContentBase from '../../ContentBase'
import './Styles.scss'

const PublicContentCoinhub = (): JSX.Element => {
    return <PublicContentBase />
}

export default PublicContentCoinhub
